import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

function broofa() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random()*16|0, v = c === 'x' ? r : (r&0x3|0x8);
    return v.toString(16);
  });
}

const useAuthCheck = () => {
  const history = useHistory();
  const [valid, setValid] = useState(false);

  useEffect(() => {
    if (window.location.hostname.includes('new-selection-page') || process.env.REACT_APP_SKIP_CHECK === 'true') {
      setValid(true);
      return;
    }

    const checkUrl = async () => {
      let isValid = false;
      try {
        const currentUrl = new URL(window.location.href);
        const landingUrl = new URL(`${window.location.origin}`);
        const signCheckUrl = new URL(`${window.location.origin}/api/checkSign`);
        landingUrl.searchParams.set('ts', currentUrl.searchParams.get('ts') || localStorage.getItem('landingTs') || '');
        landingUrl.searchParams.set('user', currentUrl.searchParams.get('user') || localStorage.getItem('landingUser') || '');
        landingUrl.searchParams.set('sign', currentUrl.searchParams.get('sign') || localStorage.getItem('landingUser') || '');
        signCheckUrl.searchParams.set('url', landingUrl.toString());
        if (!currentUrl.searchParams.get('sign'))
        {
          signCheckUrl.searchParams.set('url', localStorage.getItem('landingUrl') || '');
        }

        const resp = await fetch(signCheckUrl.toString());
        const data = await resp.json();
        isValid = data.valid;
        if (currentUrl.searchParams.get('sign'))
        {
          localStorage.setItem('landingUrl', landingUrl.toString());

          if (currentUrl.pathname === '/' && !sessionStorage.getItem('eventId'))
          {
            sessionStorage.setItem('eventId', broofa());
          }
        }
        if (currentUrl.searchParams.get('ts'))
        {
          localStorage.setItem('landingTs', currentUrl.searchParams.get('ts') || '');
        }
        if (currentUrl.searchParams.get('user'))
        {
          localStorage.setItem('landingUser', currentUrl.searchParams.get('user') || '');
        }
        if (currentUrl.searchParams.get('sign'))
        {
          localStorage.setItem('landingSign', currentUrl.searchParams.get('sign') || '');
        }
      } catch (err) {
        return false;
      }

      return isValid;
    };

    checkUrl().then(isValid => {
      setValid(isValid);
      if (!isValid) {
        history.push('/error?type=unauthorized');
      }
    });
  }, [history, setValid]);
  return valid;
};

export default useAuthCheck;
